import React from 'react'
import QRCode from 'react-qr-code';
import { imageBaseUrl } from '../../config/http';

const SuratSemuaToko = ({ detailPenjualan, dataPrint, isOpen, isTertunda }) => {
    const trxData = detailPenjualan || dataPrint;

    function numberWithCommas(x) {
        if (x === null || x === undefined || x === '') return '0';
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const tanggal = isTertunda
        ? (trxData?.tanggal_surat ? String(trxData.tanggal_surat).split(' ')[0] : '')
        : (trxData?.created_at
            ? String(trxData.created_at).split(' ')[0]
            : (trxData?.tanggal ? String(trxData.tanggal).split(' ')[0] : ''));

    const getImageUrl = () => {
        const g = trxData?.item?.gambar1;
        if (!g) return '';
        if (Array.isArray(g)) {
            if (g.length === 0) return '';
            if (typeof g[0] === 'object' && g[0] !== null) {
                return g[0].asli ? `${imageBaseUrl}${g[0].asli}` : '';
            }
            return `${imageBaseUrl}${g[0]}`;
        }
        if (typeof g === 'string') {
            try {
                const parsed = JSON.parse(g);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    if (typeof parsed[0] === 'object' && parsed[0] !== null) {
                        return `${imageBaseUrl}${parsed[0].asli || parsed[0]}`;
                    }
                    return `${imageBaseUrl}${parsed[0]}`;
                }
            } catch {
                return `${imageBaseUrl}${g}`;
            }
        }
        return '';
    };
    const imgSrc = getImageUrl();

    // Normalisasi pembayaran (mendukung split bayar)
    const totalHarga = Number(trxData?.total_harga) || 0;
    const rawPayments = Array.isArray(trxData?.payments) && trxData.payments.length > 0
        ? trxData.payments
        : [{ metode_pembayaran: trxData?.metode_pembayaran || 'cash', nominal: totalHarga }];

    const sumMetode = (key) => rawPayments
        .filter((p) => String(p.metode_pembayaran || '').toLowerCase() === key)
        .reduce((acc, p) => acc + (Number(p.nominal) || 0), 0);

    const nominalTunai = sumMetode('cash') + sumMetode('tunai');
    const nominalTransfer = sumMetode('transfer');
    const nominalQris = sumMetode('qris');
    const nominalEdc = sumMetode('edc');

    const formatRupiahDot = (nom) => `Rp${numberWithCommas(nom).replace(/,/g, '.')}`;

    // Berat mata (hanya tampil jika item memiliki nilainya)
    const beratMata = trxData?.item?.berat_potongan_mata;
    const hasBeratMata = beratMata !== null && beratMata !== undefined && beratMata !== '' && Number(beratMata) > 0;

    return (
        <div className="">
            <div className="flex flex-col items-end">
                <div className="mt-[27px] mr-[41px] w-[329px] h-[91px] px-2">
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px] mt-[13px] text-[7px]">
                            <div className=" text-sm">{ trxData?.created_at_day }</div>
                            {/* <div className=" text-sm">{isOpen ? tanggal : ''}</div> */}
                        </div>
                    </div>
                    {/* <div className="flex justify-end mt-[21px]">
                        <div className="w-[191px] h-[13px]  text-[12px]">ali / 087750999553</div>
                    </div> */}
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px] mt-[12px] text-[7px]">
                            <div className="text-sm">{trxData?.nama_pembeli || ' '}</div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <div className="w-[210px] h-[13px] text-[12px]">
                            <div className="text-sm">{trxData?.no_hp || ' '}</div>
                        </div>
                    </div>
                    <div className="flex ml-[85px] mt-[20px]">
                        <div className="w-[132px] h-[13px] text-[13px] font-bold">
                            <div className="text-[15px]">{trxData?.item?.kode_item || '-'} </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Baris Utama Tabel Barang */}
            <div className="mt-[40px] ml-[72px] flex">
                <div className="h-[125px] w-[174px] text-[11px] font-bold p-3">
                    <div className="ml-[18px]">
                        {isOpen && imgSrc ? (
                            <img
                                width={150}
                                height={180}
                                style={{ maxHeight: '260px', maxWidth: '380px' }}
                                src={imgSrc}
                                alt=""
                            />
                        ) : (
                            <div className="ml-[20px] w-[120px] h-[120px] mb-2"></div>
                        )}
                    </div>
                </div>
                <div className="h-[102px] mt-[23px] w-[224px] text-[11px] font-bold p-3">
                    <h2 className="font-semibold text-sm ">
                        {trxData?.item?.jenis_kategori?.nama_jenis || trxData?.jenis_kategori?.nama_jenis || '-'}
                    </h2>
                    {hasBeratMata && <h2 className="font-semibold text-sm ">Berat Mata</h2>}
                </div>
                <div className="h-[102px] mt-[23px] w-[86px] text-[11px] font-bold pt-3 ">
                    <h2 className="font-semibold text-sm">{trxData?.item?.berat ?? '-'}</h2>
                    {hasBeratMata && <h2 className="font-semibold text-sm">{beratMata}</h2>}
                </div>
                <div className="h-[102px] mt-[23px] w-[64px] text-[11px] font-bold p-3">
                    <h2 className="font-semibold whitespace-nowrap text-sm">{trxData?.item?.karat ?? '-'}</h2>
                </div>
                <div className="h-[102px] mt-[23px] w-[108px] text-[11px] font-bold pl-5 pt-3">
                    <div className="">
                        <QRCode value={trxData?.kode_trx || 'unknown'} size={60} />
                        <span className="text-[8px] text-center">{trxData?.kode_trx || '-'}</span>
                    </div>
                </div>
                <div>
                    <div className="h-[102px] mt-[23px] w-[155px] text-[11px] p-3">
                        <h2 className="font-semibold text-sm ml-[22px] whitespace-nowrap">
                            Rp{numberWithCommas(trxData?.total_harga ?? 0)}
                        </h2>
                    </div>
                </div>
            </div>

            {/* Baris Baru: Metode Pembayaran (Tunai | TF | QRIS | EDC) */}
            <div className="mt-[30px] ml-[72px] flex items-center">
                {/* Area Label "Metode Pembayaran" (sejajar kolom gambar) */}
                <div className="w-[174px] h-[22px]" />

                {/* Area Nilai Tunai, TF, QRIS, EDC (sejajar dengan 5 kolom kanan = 637px) */}
                <div className="w-[637px] h-[22px] grid grid-cols-4 items-center text-[11px] font-semibold">
                    <div className="pl-[68px] whitespace-nowrap">
                        {nominalTunai > 0 ? formatRupiahDot(nominalTunai) : ' '}
                    </div>
                    <div className="pl-[54px] whitespace-nowrap">
                        {nominalTransfer > 0 ? formatRupiahDot(nominalTransfer) : ' '}
                    </div>
                    <div className="pl-[42px] whitespace-nowrap">
                        {nominalQris > 0 ? formatRupiahDot(nominalQris) : ' '}
                    </div>
                    <div className="pl-[38px] whitespace-nowrap">
                        {nominalEdc > 0 ? formatRupiahDot(nominalEdc) : ' '}
                    </div>
                </div>
            </div>

            {/* Tanggal / Waktu Cetak Bawah */}
            <div className="mt-[50px] mr-[5px] flex flex-col items-end">
                {/* <div className="flex flex-col"> */}
                    {/* <div className="flex"> */}
                        <div className="w-[140px] mt-[10px] text-[10px]">
                            <div className="text-xs">{ trxData?.created_at }</div>
                            {/* <div className=" text-sm">{isOpen ? tanggal : ''}</div> */}
                        </div>
                    {/* </div> */}
                {/* </div> */}
            </div>
        </div>
    )
}

export default SuratSemuaToko
